import React from 'react';
import {createMesh, type MeshType} from 'api/generated';
import {Button, InputFile, Modal} from 'components';
import {useCreateFile} from 'hooks';

interface IModalModelUploadProps {
  visible: boolean;
  onClose: () => void;
  onUploaded: (mesh: MeshType) => void;
}

const ModalModelUpload = ({visible, onClose, onUploaded}: IModalModelUploadProps) => {
  const {handleUpload, inputRef, isPending, progress} = useCreateFile({
    createFile: createMesh,
    callback: onUploaded,
  });
  return (
    <Modal visible={visible} onClose={onClose} backdropClose={!isPending}>
      <InputFile
        inputRef={inputRef}
        buttonText="+ Add model file"
        accept="model/gltf-binary"
        supportedFormats={['glb', 'gltf']}
        onUpload={handleUpload}
        loading={isPending}
        progress={progress}
      />
      <div className="w-full flex flex-col items-center mt-5">
        <Button text="Cancel" variant="secondary" size="extra-small" onClick={onClose} disabled={isPending} />
      </div>
    </Modal>
  );
};

export default React.memo(ModalModelUpload);
